import eventBus from '../../utils/emitter-event-bus';
import { NavigatorEventBus, POI_ID } from '../navigator/navigator.model';
import { AutosaveValue, AutosaveKey } from './autosave.model';

export class Autosave {
  private static instance: Autosave;

  constructor() {
    eventBus.on(NavigatorEventBus.navigationEnd, (poi) => this.autosave(poi));
  }

  static getInstance(): Autosave {
    if (!Autosave.instance) {
      Autosave.instance = new Autosave();
    }

    return Autosave.instance;
  }

  autosave(poi: POI_ID): void {
    this.save({ poi });
  }

  get autosaveValue(): AutosaveValue | null {
    const autosaveValue = localStorage.getItem(AutosaveKey);
    if (!autosaveValue) return null;
    const parsedAutosaveValue = JSON.parse(autosaveValue);
    if (this.isAutosaveValue(parsedAutosaveValue)) {
      return parsedAutosaveValue;
    }
    return null;
  }

  save(partial: Partial<AutosaveValue>): void {
    const merged = { ...(this.autosaveValue ?? {}), ...partial };
    if (!merged.poi) return; // never persist without a POI anchor
    localStorage.setItem(AutosaveKey, JSON.stringify(merged));
  }

  get currentPOI(): POI_ID | null {
    return this.autosaveValue?.poi || null;
  }

  private isAutosaveValue(value: AutosaveValue): value is AutosaveValue {
    return (value satisfies AutosaveValue).poi !== undefined;
  }
}
